module.exports = __webpack_public_path__ + "img/fb.8d470718.svg";